import { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const useStyles = makeStyles((theme) => ({
  root: {
    float:'right',
    bottom: '2rem',
    right: '2rem',
    position:'fixed'
  },
}));

const BackToTopButton = () => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(true);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(true);
    }
  };

  const handleBackToTopClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Attach scroll event listener to window
  window.addEventListener('scroll', handleScroll);

  return (
    <Fab
      className={classes.root}
      color="primary"
      aria-label="back to top"
      onClick={handleBackToTopClick}
      style={{ display: isVisible ? 'inline-flex' : 'none' }}
    >
      <KeyboardArrowUpIcon />
    </Fab>
  );
};

export default BackToTopButton;
